// "Add Note in The Notes List" for one cue: shared by the cue in PDF view (cue-header.vue) and the List view row, so
// the access checks stay in one place. Opens Notes List's Add Note for the cue, or tells the person why it can't.
import { openAddNoteUrl } from '@/lib/lxnotes-links';
import {
    hasNotesListIntegrationAccess,
    fetchNotesListSyncAccess,
    notesListIntegrationUpgradeMessage
} from '@/lib/noteslist-integration-access';

export default async function openNotesListAddNote({ project, user, cue, toast }) {
    const productionId = project && project.noteslist_production_id;
    if (!productionId) {
        return;
    }

    // Dual / local integration flag
    if (hasNotesListIntegrationAccess(user)) {
        openAddNoteUrl(productionId, cue);
        return;
    }
    // Per-project show pass
    if (project.noteslist_show_pass_active) {
        openAddNoteUrl(productionId, cue);
        return;
    }
    // Individual Cuelist + Individual Notes List (same both-sides gate as sync)
    const status = await fetchNotesListSyncAccess(project.id);
    if (status && status.allowed) {
        openAddNoteUrl(productionId, cue);
        return;
    }

    // "not_linked" only gets the link-your-accounts message for a
    // self subscription — a license seat's billing subject is its
    // parent, and a Cuelist-only parent needs "upgrade your team
    // plan," not "go connect an account" (see integration-enabled.js).
    const reason = status && !status.viaParent ? status.reason : null;
    toast.info(notesListIntegrationUpgradeMessage(reason));
}


// WEBPACK FOOTER //
// ./src/lib/noteslist-add-note.js